import options from './md-custom-column.directive';

export default {
    selector: 'mdCustomColumn',
    options
};



// WEBPACK FOOTER //
// ./app/common/md-custom-column/index.js